import { Typography } from '@occc-app/design-system';

import type { MessageComponentProps } from './message-types.types';

import { TEXT_WRAP_SX } from '../../../../drive-insights.constants';

export const DefaultMessage = ({ message }: MessageComponentProps) => (
  <Typography sx={TEXT_WRAP_SX}>{message.content}</Typography>
);
